module.exports = __webpack_public_path__ + "static/Banner-29-7485175f3838eda6085b02811c83504c.png";